module.exports = __webpack_public_path__ + "static/assets/282b9204aeb8060ae2487e0b14613514.svg";